<tt-page *ngIf="!!setting">
    <ng-container *ngIf="tabletSize.matches; else mobileView">
        <tt-card *ngIf="itemState === 'p2releasenoteedit'" class="col-xs-12 col-md-9 p-5" ttHeading="h_release_notes"></tt-card>

        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-6 p-5">
                <tt-input ttRememberId="w_p2releasenote.searchtext" ttLabel="searchtext" ttFocus [(ttModel)]="setting.searchtext" ttShowClearButton></tt-input>
            </tt-card>

            <tt-card *ngIf="setting.show === '1'" class="col-xs-12 col-md-3 p-5">
                <tt-button ttText="register_new_p2releasenote" ttTextAlign="left" ttIcon="fas fa-plus" (ttClick)="createReleaseNote($event)"></tt-button>
            </tt-card>
        </div>

        <tt-list *ngIf="itemState !== 'p2releasenoteedit'"
                 class="col-xs-12 p-5"
                [ttData]="itemsListReleaseNotes"
                [ttFilter]="setting.searchtext">
        </tt-list>

        <ng-container *ngIf="itemState === 'p2releasenoteedit'">
            <tt-list *ngIf="selectedReleaseNoteKeyno === ''"
                     class="col-xs-12 p-5"
                    [ttData]="itemsListReleaseNotes"
                    [ttFilter]="setting.searchtext"
                    (ttClick)="openReleaseNote($event.item)">
            </tt-list>

            <div *ngIf="selectedReleaseNoteKeyno !== ''" class="col-xs-12 sp-0">
                <tt-divider ttRememberId="p2releasenote_edit_dividers">
                    <tt-divider-columns>
                        <tt-divider-pane ttSize="60">
                            <tt-list class="col-xs-12 p-5"
                                     [ttData]="itemsListReleaseNotes"
                                     [ttFilter]="setting.searchtext"
                                     (ttClick)="openReleaseNote($event.item)">
                            </tt-list>
                        </tt-divider-pane>

                        <tt-divider-pane ttSize="40">
                            <tt-p2-release-note-edit class="col-xs-12 p-5"
                                                     [inline]="true"
                                                     [p2ReleaseNoteKeyno]="selectedReleaseNoteKeyno"
                                                     (onSave)="updateReleaseNotes()">
                            </tt-p2-release-note-edit>
                        </tt-divider-pane>
                    </tt-divider-columns>
                </tt-divider>
            </div>
        </ng-container>
    </ng-container>

    <ng-template #mobileView>
        <tt-card class="col-xs-12 sp-0">
            <tt-input ttRememberId="w_p2releasenote.searchtext" ttLabel="searchtext" ttFocus [(ttModel)]="setting.searchtext" ttShowClearButton></tt-input>
            <tt-button-goto
                *ngIf="setting.show === '1'"
                ttText="register_new_p2releasenote"
                ttGoto="p2releasenoteedit"
                [ttGotoParms]="{ p2_releasenote_keyno: '0' }"
                ttTextAlign="left"
                ttIcon="fas fa-plus">
            </tt-button-goto>
        </tt-card>

        <tt-list
            [ttData]="itemsListReleaseNotes"
            [ttFilter]="setting.searchtext">
        </tt-list>
    </ng-template>
</tt-page>
